import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { PrimaryButton } from "../../../ui/buttons/Button";
import useTable from "../../useTable";
import CatalogoMarca from "../../../catalogos/catalgoMarca";

export const GestionarMarca = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const txtBuscador = useRef();
  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState();
  const [marca, setMarca] = useState();
  const [activate, setActivate] = useState(false);
  const [catalogoMarca, setCatalogoMarca] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "idmarca",
      label: "CODIGO",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descripcion",
      label: "DESCRIPCION",
      width: "440px",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      width: "180px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const seleccionarRegistros = async () => {
    try {
      setActivate(true);
      const campos = "idmarca, trim(descripcion) as descripcion";
      const nomtab = "marca";
      const orden = "idmarca";
      const endpoint =
        op.conexion +
        `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setRecords(response.data);
          }
        })
        .catch(function (error) {})
        .finally(() => {
          setActivate(false);
          txtBuscador.current?.focus();
        });
    } catch (error) {}
  };
  const cerrar = () => {
    blanquear();
    if (props.onHideCancelar) props.onHideCancelar();
    if (props.setShow) props.setShow(false);
    props.cerrar();
  };
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idmarca.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const imprimir = () => {
    window.open(
      `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListMarca`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const blanquear = () => {};

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Gestion de Marca.</h3>
        <a type="button" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? cerrar()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} inverted></Dimmer>
      <div className="col-12">
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
              <input
                type={"text"}
                className="form-control text-uppercase"
                onChange={handleSearch}
                placeholder="Buscar Marca..."
                ref={txtBuscador}
              />
              <button className="btn btn-sm btn-info" onClick={imprimir}>
                <i className="fas fa-print m-0" />
              </button>
            </div>
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              onClick={() => {
                setMarca();
                setCatalogoMarca(true);
                setOperacion(1);
              }}
              className="btn btn-sm btn-info"
              icon="fa-plus m-0"
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idmarca} style={{ padding: "0" }}>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idmarca}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="mx-auto"
                      align="center"
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setMarca(item);
                          setCatalogoMarca(true);
                          setOperacion(4);
                        }}
                        className={"btn btn-sm btn-info rounded-circle"}
                      >
                        <i className="fas fa-eye"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={() => {
                          setMarca(item);
                          setCatalogoMarca(true);
                          setOperacion(2);
                        }}
                        className={"btn btn-sm btn-warning rounded-circle"}
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={() => {
                          setMarca(item);
                          setCatalogoMarca(true);
                          setOperacion(3);
                        }}
                        className={"btn btn-sm btn-danger rounded-circle"}
                      >
                        <i className="fa fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </div>
      <CatalogoMarca
        show={catalogoMarca}
        marca={marca}
        onHideCancelar={() => setCatalogoMarca(false)}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
      />
    </Modal>
  );
};
